import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, TableHead, TableRow } from '@mui';
import SortIconButton from '@shared/data-table/header/sort-icon-button';
import Cell from './cell';
import './head.scss';

const getColumnWidth = width => width ? ({
  maxWidth: `${width}rem`,
  minWidth: `${width}rem`,
  width: `${width}rem`
}) : {};

const Head = ({ checkedProps, columns, dataType, onToggleAll, stickyFirstColumn, subType }) => (
  <TableHead>
    <TableRow>
      {columns.map((column, columnIndex) => {
        const isFirstColumn = columnIndex === 0 && stickyFirstColumn;
        const style = {
          ...getColumnWidth(column.width),
          ...(column.style || {}),
          whiteSpace: 'nowrap',
          ...(isFirstColumn && {
            position: 'sticky',
            left: 0,
            zIndex: 3 // Above other header cells (stickyHeader uses z-index 2)
          })
        };
        // A column with no visible label (the checkbox/actions "dummy" columns) still needs a
        // real accessible name for its <th> - a visually-hidden span with actual text, not just
        // aria-label, since axe/IBM's "empty table header" check only looks at text content.
        const hiddenLabel = !column.label && column.ariaLabel && (
          <span styleName="visually-hidden">{column.ariaLabel}</span>
        );

        if (column.key === 'checkbox') {
          const { isAllChecked, isAnyChecked } = checkedProps;
          return (
            <Cell key={`header-${column.key}`} style={style}>
              {hiddenLabel}
              <Checkbox
                checked={isAnyChecked}
                indeterminate={isAnyChecked && !isAllChecked}
                onChange={onToggleAll}
                onClick={event => event.stopPropagation()}
                inputProps={{ 'aria-label': column.ariaLabel }}
                size="small"
              />
            </Cell>
          );
        }
        // Only show sort button if dataType is provided and column has ordering
        const showSort = dataType && column.ordering;
        return (
          <Cell key={`header-${column.key}`} style={style}>
            <div styleName="header-cell-wrapper">
              {hiddenLabel}
              <span>{column.label}</span>
              {showSort && (
                <SortIconButton
                  column={column}
                  dataType={dataType}
                  subType={subType}
                />
              )}
            </div>
          </Cell>
        );
      })}
    </TableRow>
  </TableHead>
);

Head.propTypes = {
  checkedProps: PropTypes.object,
  columns: PropTypes.array,
  dataType: PropTypes.string,
  onToggleAll: PropTypes.func,
  stickyFirstColumn: PropTypes.bool,
  subType: PropTypes.string
};

export default Head;
